const moment = require("moment");

const datesAreSame = (start, end) => moment(start).isSame(end, "day");

module.exports = datesAreSame;
